import { userApi } from '@/lib/axios';

export const postUpdateUserLanguage = (data) => {
  return userApi.post('/user/update-user-language', data);
};
